var map = {
	"./Settings.png": "349e",
	"./background/back.png": "8ce7",
	"./background/main-banner-blurred.png": "4183",
	"./background/main-banner-mobile.png": "af7b",
	"./background/main-banner-mobile2.png": "1033",
	"./background/main-banner.png": "9722",
	"./bag-design-tool.png": "25d9",
	"./chevron-down.png": "0fc3",
	"./icon_1.png": "8f7b",
	"./icon_2.png": "a96d",
	"./icon_3.png": "ed50",
	"./icon_4.png": "b08b",
	"./icon_5.png": "7b79",
	"./logo.png": "9d64",
	"./modelDefalutScreen.png": "e767",
	"./models/Model-R-11x5x28.png": "f766",
	"./models/Model11x5x28.png": "ad4a",
	"./models/m1.png": "b854",
	"./models/m2.png": "deff",
	"./models/m3.png": "01c9",
	"./models/m4.png": "170a",
	"./models/m5.png": "224f",
	"./models/m6.png": "e903",
	"./models/model15x5x24.png": "e8b6",
	"./models/sac-sandwich-papier.png": "e201",
	"./step1.png": "ad97",
	"./step5.png": "559e",
	"./step6.png": "8d24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";